import React from 'react';
type VolumeCoverProps = {
  number: number;
};
export function VolumeCover({
  number
}: VolumeCoverProps) {
  return <div className="flex aspect-[3/4] w-12 shrink-0 flex-col items-center justify-between rounded-[3px] border border-navy-line bg-ivory-deep px-1 py-1.5 shadow-card sm:w-14" aria-hidden="true" data-id="element-114" data-mp="2lmyovjh38xk3">
      <span className="text-[0.42rem] font-bold uppercase tracking-[0.06em] text-sand sm:text-[0.46rem]" data-id="element-115" data-mp="2uo6e7c1mmo21">
        Vol {number}
      </span>
      <span className="text-center font-display text-[0.44rem] font-semibold uppercase leading-[1.1] text-navy sm:text-[0.5rem]" data-id="element-116" data-mp="2200salyu6t0m">
        OT Clinical Toolkit
      </span>
      <span className="h-1.5 w-full rounded-[1px] bg-teal/70" data-id="element-117" data-mp="26xswaecra5l6" />
    </div>;
}